module.exports = __webpack_public_path__ + "img/shopping-cart.4dc2eeb7.gif";